import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as ConfigService from 'services/messaging/mobile/config';

export const useMobilePushConfigService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchConfig = async (options = {}) => {
    const { error, payload } = await ConfigService.read({ ...options, token });
    if (error) {
      return {
        configs: [],
        size: 0
      };
    }

    const {
      data: configs,
      meta: { size }
    } = payload;
    return { configs, size };
  };

  const updateConfig = async (options = {}) => {
    const { error, payload } = await ConfigService.create({
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to save configuration at this time. Please try again.');
    } else {
      toast.success('Configuration saved successfully.');
    }
    return { config: payload };
  };

  return { fetchConfig, updateConfig };
};
